import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Table,
  Input,
  Select,
  Space,
  Avatar,
  Tag,
  Button,
  Row,
  Col
} from 'antd';

import {
  SearchOutlined,
  UserOutlined,
  HomeOutlined,
  FilterOutlined,
  EyeOutlined
} from '@ant-design/icons';
import { taskUsers } from '../store/tasksApi/tasksThunk';
import { fetchRoles, fetchUsers } from '../store/adminApi/adminThunk';
import { Link, useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';
import { getAccessToken } from '../utils/tokenCookies';

const { Option } = Select;

// Props: onUserClick - faqat sahifaga o'tish uchun
const UsersListPage = ({ onUserClick }) => {



  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [selectedRole, setSelectedRole] = useState(null);

  // Redux state
  const { users = [], loading: usersLoading } = useSelector((state) => state.adminApi);
  const { roles = [], loading: rolesLoading } = useSelector(
    (state) => state.adminApi || { roles: [], loading: false }
  );


  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchRoles());
  }, [dispatch]);

  const handleUserClick = (userId) => {
    if (onUserClick) {
      onUserClick(userId);
    }

  };

  const getFilteredUsers = () => {
    let filtered = [...users];

    if (searchText) {
      const search = searchText.toLowerCase();
      filtered = filtered.filter(user => {
        const fullName = `${user.surname} ${user.first_name} ${user.patronymic}`.toLowerCase();
        return fullName.includes(search);
      });
    }

    if (selectedRole) {
      filtered = filtered.filter(user =>
        user.roles && user.roles.some(r => r.id === selectedRole)
      );
    }

    return filtered;
  };

  const getUserRoles = (user) => {
    return user.roles || [];
  };


  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 60,
      render: (text, record, index) => index + 1
    },
    {
      title: 'Rasm',
      dataIndex: 'picture',
      key: 'picture',
      width: 80,
      render: (picture) => (
        <Avatar
          size={50}
          src={picture}
          icon={<UserOutlined />}
        />
      )
    },
    {
      title: 'F.I.O',
      key: 'fullName',
      render: (_, record) => (
        <Link
          to={`/users/${record.id}`}
          onClick={() => handleUserClick(record.id)}
          style={{ padding: 0, height: 'auto' }}
        >
          {record.surname} {record.first_name} {record.patronymic}
        </Link>
      )
    },
    {
      title: 'Bo\'lim',
      dataIndex: 'departments',
      key: 'department',
      render: (departments) => {
        if (!departments || departments.length === 0) return '-';
        const dept = departments[0];
        return dept.department_name?.name || '-';
      }
    },

    {
      title: 'Rollar',
      key: 'roles',
      render: (_, record) => {
        const userRoles = getUserRoles(record);
        return (
          <Space size={[0, 8]} wrap>
            {userRoles.length > 0 ? (
              userRoles.map(role => (
                <Tag color="blue" key={role.id}>
                  {role.name}
                </Tag>
              ))
            ) : (
              <Tag>Rolsiz</Tag>
            )}
          </Space>
        );
      }
    },
    {
      title: 'Amallar',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Link to={`/admin/users/${record.id}/tasks`}>
          <Button
            type="primary"
            size="small"
            icon={<EyeOutlined />}
          >
            Vazifalar
          </Button>
        </Link>
      )
    }


  ];

  const filteredUsers = getFilteredUsers();
  const loading = usersLoading || rolesLoading;

  // const navigate = useNavigate();

  // const token = getAccessToken();
  // const userRoles = getUserRoles(token);

  // useEffect(() => {
  //   if (!userRoles.includes("superadmin")) {
  //     navigate("/403"); // Agar superadmin bo‘lmasa → 403 page
  //   }
  // }, [navigate, userRoles]);


  return (
    <div  >
      <Breadcrumb className="py-2">
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Foydalanuvchilar ro'yxati</Breadcrumb.Item>
      </Breadcrumb>

      <Card bordered={false}>
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12} md={8}>
            <Input
              placeholder="Xodimni qidirish..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
              size="middle"
            />
          </Col>
          <Col xs={24} sm={12} md={8}>
            <Select
              placeholder="Rol bo'yicha filterlash"
              style={{ width: '100%' }}
              value={selectedRole}
              onChange={setSelectedRole}
              allowClear
              size="middle"
              loading={rolesLoading}
              suffixIcon={<FilterOutlined />}
            >
              {roles.map(role => (
                <Option key={role.id} value={role.id}>
                  {role.name}
                </Option>
              ))}
            </Select>

          </Col>

        </Row>

        <Table
          columns={columns}
          dataSource={filteredUsers}
          rowKey="id"
          loading={loading}
          pagination={{
            pageSize: 50,
            showTotal: (total) => `Jami: ${total} ta xodim`,
          }}
          scroll={{ x: 1000 }}
        />
      </Card>
    </div>
  );
};

export default UsersListPage;